import styled from 'styled-components';

export const Container = styled.div`
  & > .title {
    font-size: 1rem;
    font-weight: 700;
  }

  & > .message {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;
